import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, renderList as _renderList, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b3d1fa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = { class: "inner1" }
const _hoisted_7 = { class: "title_left" }
const _hoisted_8 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※", -1))
const _hoisted_13 = ["max"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "設定対象", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label1" }, "デフォルト", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label2" }, "エージェントセグメント", -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label2" }, "個別エージェント", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label2" }, "AGコード", -1))
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "" }
const _hoisted_27 = {
  key: 0,
  class: "tableLabel"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label1" }, "現在の設定", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label3" }, "反映日", -1))
const _hoisted_30 = { class: "label3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "管理ID：", -1))
const _hoisted_32 = {
  class: "table table-bordered",
  id: "nowSetting"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "削除"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_catgory" }, "カテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_parentCategory" }, "親カテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_dispName" }, "表示名"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_url" }, "URL"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_link" }, "リンク確認"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_dispTarget" }, "表示順"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_separateTab" }, "別タブ表示")
  ])
], -1))
const _hoisted_34 = {
  class: "col_selection",
  "data-name": "mSelection"
}
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = ["onUpdate:modelValue", "onChange"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_38 = ["value"]
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "unchanged" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = {
  key: 0,
  class: "unchanged"
}
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 1,
  style: {"text-align":"left","padding-left":"12px"}
}
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = { class: "unchanged" }
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { class: "form-footer" }
const _hoisted_51 = {
  class: "form-group",
  style: {"text-align":"right"}
}
const _hoisted_52 = {
  key: 0,
  class: "form-group",
  style: {"text-align":"center"}
}
const _hoisted_53 = {
  key: 1,
  class: ""
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_55 = { class: "tableLabel" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label1" }, "反映予定の設定", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label2" }, "反映日", -1))
const _hoisted_58 = ["max"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "管理ID：", -1))
const _hoisted_60 = {
  key: 0,
  class: "table table-bordered"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "削除"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_catgory" }, "カテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_parentCategory" }, "親カテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_dispName" }, "表示名"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_url" }, "URL"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_link" }, "リンク確認"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_dispTarget" }, "表示順"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_separateTab" }, "別タブ表示")
  ])
], -1))
const _hoisted_62 = {
  class: "col_selection",
  "data-name": "mSelection"
}
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = ["onUpdate:modelValue", "onChange"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_66 = ["value"]
const _hoisted_67 = ["onUpdate:modelValue"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_69 = ["value"]
const _hoisted_70 = { class: "unchanged" }
const _hoisted_71 = ["onUpdate:modelValue"]
const _hoisted_72 = {
  key: 0,
  class: "unchanged"
}
const _hoisted_73 = ["onUpdate:modelValue"]
const _hoisted_74 = {
  key: 1,
  style: {"text-align":"left","padding-left":"12px"}
}
const _hoisted_75 = ["disabled", "onClick"]
const _hoisted_76 = { class: "unchanged" }
const _hoisted_77 = ["onUpdate:modelValue"]
const _hoisted_78 = {
  class: "form-group",
  style: {"text-align":"right"}
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "※リンクの確認およびプレビューは、入力後、確定をしないと反映されません。", -1))
const _hoisted_80 = { class: "form-inline flex-container" }
const _hoisted_81 = { class: "form-group" }
const _hoisted_82 = {
  key: 0,
  class: "form-group"
}
const _hoisted_83 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_NumericInput = _resolveComponent("NumericInput")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, [
                (_ctx.isEditModeUpdate)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("グローバルナビ編集")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("グローバルナビ登録")
                    ], 64))
              ])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, [
                _hoisted_10,
                _createTextVNode(" 設定名 "),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "txtSettingName",
                  class: "text1 form-control",
                  maxlength: "255",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.glovalnaviKanriData.settingName) = $event)),
                  ref: "txtSettingName"
                }, null, 512), [
                  [_vModelText, _ctx.glovalnaviKanriData.settingName]
                ])
              ]),
              (!_ctx.isEditModeUpdate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(" 反映日 "),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "reflectionDate",
                      class: "form-control",
                      max: _ctx.AppConstants.MAX_DATE_VALUE,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reflectionDate) = $event))
                    }, null, 8, _hoisted_13), [
                      [_vModelText, _ctx.reflectionDate]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("fieldset", null, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "rdoDefault",
                  name: "targetSetting",
                  class: "form-check-input",
                  value: "0",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.glovalnaviKanriData.settingTargetKbn) = $event)),
                  disabled: _ctx.isDefaultId,
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChangeSettingTarget && _ctx.onChangeSettingTarget(...args)))
                }, null, 40, _hoisted_15), [
                  [_vModelRadio, _ctx.glovalnaviKanriData.settingTargetKbn]
                ]),
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "rdoAgsegment",
                  name: "targetSetting",
                  class: "form-check-input",
                  value: "1",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.glovalnaviKanriData.settingTargetKbn) = $event)),
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChangeSettingTarget && _ctx.onChangeSettingTarget(...args)))
                }, null, 544), [
                  [_vModelRadio, _ctx.glovalnaviKanriData.settingTargetKbn]
                ]),
                _hoisted_17,
                _withDirectives(_createElementVNode("select", {
                  id: "agSegmentList",
                  class: "select1 form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.glovalnaviKanriData.settingTargetCode) = $event)),
                  disabled: !_ctx.isGlonaviTargetSegment
                }, [
                  _hoisted_19,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agSegmentList, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.agSegmentCode,
                      value: item.agSegmentCode
                    }, [
                      (_ctx.isGlonaviTargetSegment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.agSegmentCode) + "：" + _toDisplayString(item.agSegmentName), 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_20))
                  }), 128))
                ], 8, _hoisted_18), [
                  [_vModelSelect, _ctx.glovalnaviKanriData.settingTargetCode]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "rdoKobetuAg",
                  name: "targetSetting",
                  class: "form-check-input",
                  value: "2",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.glovalnaviKanriData.settingTargetKbn) = $event)),
                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onChangeSettingTarget && _ctx.onChangeSettingTarget(...args)))
                }, null, 544), [
                  [_vModelRadio, _ctx.glovalnaviKanriData.settingTargetKbn]
                ]),
                _hoisted_22,
                _hoisted_23,
                (_ctx.isGlonaviTargetvCode)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "text",
                      id: "txtTitle",
                      class: "text2 form-control",
                      maxlength: "8",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.glovalnaviKanriData.settingTargetCode) = $event)),
                      disabled: !_ctx.isGlonaviTargetvCode
                    }, null, 8, _hoisted_24)), [
                      [_vModelText, _ctx.glovalnaviKanriData.settingTargetCode]
                    ])
                  : (_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "text",
                      id: "txtTitle",
                      class: "text2 form-control",
                      maxlength: "8",
                      disabled: !_ctx.isGlonaviTargetvCode
                    }, null, 8, _hoisted_25))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              (_ctx.isEditModeUpdate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _hoisted_29,
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.reflectionDate), 1),
                    _hoisted_31,
                    _createElementVNode("label", null, _toDisplayString(_ctx.glovalnaviKanriData.glonaviKanriId), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("table", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.glovalnaviKanriData.nowSettingList, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.categoryId
                    }, [
                      _createElementVNode("td", _hoisted_34, [
                        _withDirectives(_createElementVNode("input", {
                          id: "mSelection",
                          type: "checkbox",
                          class: "form-check-input",
                          "onUpdate:modelValue": ($event: any) => ((item.selection) = $event)
                        }, null, 8, _hoisted_35), [
                          [_vModelCheckbox, item.selection]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("select", {
                          id: "table",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.categoryId) = $event),
                          onChange: ($event: any) => (
                    _ctx.changeUrl(
                      item.categoryId,
                      _ctx.GlonaviManegmentConstants.GLONAVI_SETTING_NOW,
                      index
                    )
                  )
                        }, [
                          _hoisted_37,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.categoryId,
                              value: item.categoryId
                            }, _toDisplayString(item.categoryName), 9, _hoisted_38))
                          }), 128))
                        ], 40, _hoisted_36), [
                          [_vModelSelect, item.categoryId]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("select", {
                          id: "table",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.pairentId) = $event)
                        }, [
                          _hoisted_40,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.categoryId,
                              value: item.categoryId
                            }, _toDisplayString(item.categoryName), 9, _hoisted_41))
                          }), 128))
                        ], 8, _hoisted_39), [
                          [_vModelSelect, item.pairentId]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_42, [
                        _withDirectives(_createElementVNode("input", {
                          style: {"border":"powderblue solid 1px","text-align":"left","padding-left":"8px"},
                          class: "form-control unchanged",
                          id: "dispName",
                          type: "text",
                          maxlength: "15",
                          "onUpdate:modelValue": ($event: any) => ((item.dispName) = $event)
                        }, null, 8, _hoisted_43), [
                          [_vModelText, item.dispName]
                        ])
                      ]),
                      (item.categoryId == _ctx.sonotaCategoryId)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                            _withDirectives(_createElementVNode("input", {
                              style: {"border":"powderblue solid 1px","text-align":"left","padding-left":"8px"},
                              class: "form-control unchanged",
                              id: "url",
                              type: "text",
                              maxlength: "255",
                              "onUpdate:modelValue": ($event: any) => ((item.url) = $event)
                            }, null, 8, _hoisted_45), [
                              [_vModelText, item.url]
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_46, [
                            _createElementVNode("label", null, _toDisplayString(item.url), 1)
                          ])),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "mBtnUpdate",
                          class: "btn btn-primary btn-sm",
                          disabled: item.categoryId != _ctx.sonotaCategoryId,
                          onClick: ($event: any) => (
                    _ctx.onLinkCheck(
                      _ctx.GlonaviManegmentConstants.GLONAVI_SETTING_NOW,
                      item.url,
                      index
                    )
                  )
                        }, " 確認 ", 8, _hoisted_47)
                      ]),
                      _createElementVNode("td", _hoisted_48, [
                        _createVNode(_component_NumericInput, {
                          modelValue: item.dispNo,
                          "onUpdate:modelValue": ($event: any) => ((item.dispNo) = $event),
                          style: {"border":"powderblue solid 1px","text-align":"center","padding-left":"8px"},
                          class: "form-control unchanged",
                          onInput: ($event: any) => (
                    _ctx.numberLimit(
                      _ctx.GlonaviManegmentConstants.GLONAVI_SETTING_NOW,
                      index
                    )
                  )
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          id: "mSelection1",
                          type: "checkbox",
                          class: "form-check-input",
                          name: "nowStting",
                          value: 0,
                          "onUpdate:modelValue": ($event: any) => ((item.isSeparateTab) = $event)
                        }, null, 8, _hoisted_49), [
                          [_vModelCheckbox, item.isSeparateTab]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.rowAdd(_ctx.GlonaviManegmentConstants.GLONAVI_SETTING_NOW)))
                  }, " 行追加 ")
                ]),
                (_ctx.isEditModeUpdate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnBack",
                        class: "btn addbtn btn-primary",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onCopy && _ctx.onCopy(...args)))
                      }, " 下にコピーする▼ ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isEditModeUpdate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _hoisted_57,
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        id: "txtDispDtFrom",
                        class: "inputDate form-control",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.scheduledDate) = $event)),
                        max: _ctx.AppConstants.MAX_DATE_VALUE
                      }, null, 8, _hoisted_58), [
                        [_vModelText, _ctx.scheduledDate]
                      ]),
                      _hoisted_59,
                      _createElementVNode("label", null, _toDisplayString(_ctx.glovalnaviKanriData.glonaviKanriId), 1)
                    ]),
                    (_ctx.isDataFetched)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.glovalnaviKanriData.scheduleSettingList, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: item.categoryId
                              }, [
                                _createElementVNode("td", _hoisted_62, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "mSelection",
                                    type: "checkbox",
                                    class: "form-check-input",
                                    "onUpdate:modelValue": ($event: any) => ((item.selection) = $event)
                                  }, null, 8, _hoisted_63), [
                                    [_vModelCheckbox, item.selection]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("select", {
                                    id: "table",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => ((item.categoryId) = $event),
                                    onChange: ($event: any) => (
                      _ctx.changeUrl(
                        item.categoryId,
                        _ctx.GlonaviManegmentConstants.GLONAVI_SETTING_SCHEDULE,
                        index
                      )
                    )
                                  }, [
                                    _hoisted_65,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: item.categoryId,
                                        value: item.categoryId
                                      }, _toDisplayString(item.categoryName), 9, _hoisted_66))
                                    }), 128))
                                  ], 40, _hoisted_64), [
                                    [_vModelSelect, item.categoryId]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("select", {
                                    id: "table",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => ((item.pairentId) = $event)
                                  }, [
                                    _hoisted_68,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: item.categoryId,
                                        value: item.categoryId
                                      }, _toDisplayString(item.categoryName), 9, _hoisted_69))
                                    }), 128))
                                  ], 8, _hoisted_67), [
                                    [_vModelSelect, item.pairentId]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_70, [
                                  _withDirectives(_createElementVNode("input", {
                                    style: {"border":"powderblue solid 1px","text-align":"left","padding-left":"8px"},
                                    class: "form-control unchanged",
                                    id: "dispName",
                                    type: "text",
                                    maxlength: "15",
                                    "onUpdate:modelValue": ($event: any) => ((item.dispName) = $event)
                                  }, null, 8, _hoisted_71), [
                                    [_vModelText, item.dispName]
                                  ])
                                ]),
                                (item.categoryId == _ctx.sonotaCategoryId)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_72, [
                                      _withDirectives(_createElementVNode("input", {
                                        style: {"border":"powderblue solid 1px","text-align":"left","padding-left":"8px"},
                                        class: "form-control unchanged",
                                        id: "url",
                                        type: "text",
                                        maxlength: "255",
                                        "onUpdate:modelValue": ($event: any) => ((item.url) = $event)
                                      }, null, 8, _hoisted_73), [
                                        [_vModelText, item.url]
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_74, [
                                      _createElementVNode("label", null, _toDisplayString(item.url), 1)
                                    ])),
                                _createElementVNode("td", null, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    name: "mBtnUpdate",
                                    class: "btn btn-primary btn-sm",
                                    disabled: item.categoryId != _ctx.sonotaCategoryId,
                                    onClick: ($event: any) => (
                      _ctx.onLinkCheck(
                        _ctx.GlonaviManegmentConstants.GLONAVI_SETTING_SCHEDULE,
                        item.url,
                        index
                      )
                    )
                                  }, " 確認 ", 8, _hoisted_75)
                                ]),
                                _createElementVNode("td", _hoisted_76, [
                                  _createVNode(_component_NumericInput, {
                                    modelValue: item.dispNo,
                                    "onUpdate:modelValue": ($event: any) => ((item.dispNo) = $event),
                                    style: {"border":"powderblue solid 1px","text-align":"center","padding-left":"8px"},
                                    class: "form-control unchanged",
                                    onInput: ($event: any) => (
                      _ctx.numberLimit(
                        _ctx.GlonaviManegmentConstants.GLONAVI_SETTING_SCHEDULE,
                        index
                      )
                    )
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "mSelection2",
                                    type: "checkbox",
                                    class: "form-check-input",
                                    name: "scheduledSetting",
                                    value: 1,
                                    "onUpdate:modelValue": ($event: any) => ((item.isSeparateTab) = $event)
                                  }, null, 8, _hoisted_77), [
                                    [_vModelCheckbox, item.isSeparateTab]
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnBack",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (
                _ctx.rowAdd(_ctx.GlonaviManegmentConstants.GLONAVI_SETTING_SCHEDULE)
              ))
                      }, " 行追加 ")
                    ]),
                    _hoisted_79
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnDelete",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                  }, " 行削除 ")
                ]),
                (_ctx.isEditModeUpdate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnDelete",
                        class: "btn previewbtn btn-primary",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onPreview(_ctx.GlonaviManegmentConstants.GLONAVI_SETTING_NOW)))
                      }, " 現在の設定をプレビュー "),
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnDelete",
                        class: "btn previewbtn btn-primary",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (
                _ctx.onPreview(_ctx.GlonaviManegmentConstants.GLONAVI_SETTING_SCHEDULE)
              ))
                      }, " 反映予定の設定をプレビュー ")
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, " 戻る "),
                  (!_ctx.isEditModeUpdate)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        name: "btnClear",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                      }, " クリア "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnAdd",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onFixed && _ctx.onFixed(...args)))
                  }, " 確定 ")
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}